export const symbolContainerStyle = {
    position: 'absolute',
    marginLeft: 88,
    marginTop: 19
};

export const symbolStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500
};
